import type React from 'react';
import type { FC } from 'react';

import { useAppDispatch } from '../../store/react_redux_typed';
import Menu from '../../ui/menus/menu/menu';
import type { MenuItem } from '../../ui/menus/menu/types';
import type { ContextMenuReduxActions } from './types';

export type ContextMenuProps = {
  menuItems?: MenuItem[];
  actions?: ContextMenuReduxActions;
  additionalActions?: ContextMenuReduxActions;
  showIcons?: boolean;
  onMenuItemClick?: (menuItem: MenuItem, event: React.MouseEvent) => void;
  onAdditionalMenuItemClick?: (
    menuItem: MenuItem,
    event: React.MouseEvent,
  ) => void;
  contextItemsAmount?: number;
  helpMessage?: string;
  useFixedWidthForSubItems?: boolean;
};

const ContextMenu: FC<ContextMenuProps> = (props) => {
  const {
    menuItems = [],
    contextItemsAmount,
    showIcons = true,
    actions,
    onMenuItemClick,
    additionalActions,
    onAdditionalMenuItemClick,
    helpMessage,
    useFixedWidthForSubItems,
  } = props;

  const dispatch = useAppDispatch();

  const handleMenuItemClick = (
    menuItem: MenuItem,
    event: React.MouseEvent,
  ): void => {
    if (!menuItem.name) {
      return;
    }
    const action = actions?.[menuItem.name];
    if (action) {
      dispatch(action(menuItem, event));
    }
    onMenuItemClick?.(menuItem, event);
  };

  const handleAdditionalMenuItemClick = (
    menuItem: MenuItem,
    event: React.MouseEvent,
  ): void => {
    if (!menuItem.name) {
      return;
    }
    const action = additionalActions?.[menuItem.name];
    if (action) {
      dispatch(action(menuItem, event));
    }
    onAdditionalMenuItemClick?.(menuItem, event);
  };

  if (menuItems.length === 0) {
    return null;
  }

  return (
    <Menu
      menuItems={menuItems}
      onMenuItemClick={handleMenuItemClick}
      onAdditionalMenuItemClick={handleAdditionalMenuItemClick}
      showIcons={showIcons}
      contextItemsAmount={contextItemsAmount}
      helpMessage={helpMessage}
      useFixedWidthForSubItems={useFixedWidthForSubItems}
    />
  );
};

export default ContextMenu;
